var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"foobar"},[_c('button',{on:{"click":_vm.another}},[_vm._v("Start Multiply Flow")]),_c('button',{on:{"click":_vm.cancel}},[_vm._v("Cancel")]),_vm._v(" Modals within modals! ")])}
var staticRenderFns = []

export { render, staticRenderFns }